import { Link } from "react-router-dom";
import { Button } from "./ui/button";
import { ArrowLeft, Users, Pencil, Copy, Check } from "lucide-react";

/**
 * Top nav for the Group detail screen.
 *   - Back link to dashboard
 *   - Group name with optional rename pencil (owners + admins)
 *   - Invite-code chip with copy-to-clipboard feedback
 */
export function GroupNav({ group, canRename, onRename, copiedCode, onCopyInviteCode }) {
  return (
    <nav className="bg-white border-b border-stone sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 py-3 flex items-center justify-between">
        <div className="flex items-center gap-4">
          <Link
            to="/dashboard"
            className="flex items-center gap-2 text-stone-dark/60 hover:text-stone-dark transition-colors"
            data-testid="back-to-dashboard"
          >
            <ArrowLeft className="w-4 h-4" />
            <span className="hidden sm:inline">Dashboard</span>
          </Link>
          <div className="h-6 w-px bg-stone" />
          <div className="flex items-center gap-2 min-w-0">
            <div className="w-8 h-8 rounded-full bg-sage flex items-center justify-center shrink-0">
              <Users className="w-4 h-4 text-white" />
            </div>
            <span className="font-serif font-semibold text-base sm:text-lg text-stone-dark truncate">
              {group.name}
            </span>
            {canRename && (
              <button
                onClick={onRename}
                className="p-1 rounded-md text-stone-dark/40 hover:text-sage hover:bg-sage/10 transition-colors"
                title="Edit group"
                data-testid="rename-group-btn"
              >
                <Pencil className="w-4 h-4" />
              </button>
            )}
          </div>
        </div>
        <div className="flex items-center gap-2">
          <Button
            variant="outline"
            size="sm"
            className="rounded-full"
            onClick={onCopyInviteCode}
            data-testid="copy-invite-code"
          >
            {copiedCode ? <Check className="w-4 h-4 text-green-500" /> : <Copy className="w-4 h-4" />}
            <span className="ml-2 font-mono text-xs hidden sm:inline">{group.invite_code}</span>
          </Button>
        </div>
      </div>
    </nav>
  );
}
